var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCheckCircleArcade = function SvgCheckCircleArcade(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#00D64F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.52 22.9a1.5 1.5 0 0 1 .08 2.12l-16.25 17.5a1.5 1.5 0 0 1-2.32-.148l-6.25-8.75a1.5 1.5 0 0 1 2.44-1.744l5.182 7.254 14.999-16.153a1.5 1.5 0 0 1 2.12-.078Z",
    fill: "#fff"
  })));
};

export default SvgCheckCircleArcade;